<template>

	<div id="app">
		<Loading
			v-if="!loaded"
			@loaded="()=>{loaded=true}"
		></Loading>
		<Horizontal />
		<a
			class="back_btn"
			v-if="$route.name.indexOf('Home')==-1"
			@click="goBack"
		></a>
		<Music class="music" />
		<keep-alive>
			<router-view
				v-show="loaded"
				ref="page"
				v-if="$route.meta.keepAlive"
			></router-view>
		</keep-alive>
		<router-view
			v-show="loaded"
			v-if="!$route.meta.keepAlive"
		/>
	</div>
</template>
<script>
import Music from "./components/Music";
import Horizontal from "./components/Horizontal";
import Loading from "./components/Loading";
export default {
	data() {
		return {
			loaded: false,
		};
	},
	components: {
		Music,
		Horizontal,
		Loading,
	},
	methods: {
		goBack() {
			console.log();
			var name = this.$route.name;
			if (name == "List") {
				this.$router.replace({
					name: "Home",
				});
			} else if (name == "Detail") {
				var id = this.$route.params.id.split("-")[0];
				this.$router.replace({
					name: "List",
					params: {
						id,
					},
				});
			}
		},
	},
};
</script>
<style>
body {
	color: #fff;
	perspective-origin: center;
}
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}

#nav a.router-link-exact-active {
	color: #42b983;
}
.music {
	position: absolute;
	right: 0.2rem;
	top: 0.2rem;
	z-index: 10;
	padding-right: constant(safe-area-inset-right);
	padding-right: env(safe-area-inset-right);
}
.back_btn {
	width: 1rem;
	height: 1rem;
	background: url("./assets/back_icon.png") no-repeat center/contain;
	position: absolute;
	left: 0.2rem;
	top: 0.3rem;
	padding-left: constant(safe-area-inset-right);
	padding-left: env(safe-area-inset-right);
	z-index: 1000;
}
</style>
